import type { ReactNode } from 'react';

/** The centred card the three signed-out screens share. */
export default function AuthShell({
  title,
  hint,
  children,
  footer,
}: {
  title: string;
  hint?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="flex min-h-svh items-center justify-center bg-page px-5 py-10 text-ink">
      <div className="w-full max-w-[440px]">
        <img
          src="/images/mds-logo-dark.png"
          alt="MDS"
          className="mx-auto mb-8 h-16 w-auto object-contain"
        />

        <main className="rounded-2xl border border-hairline bg-surface p-7 shadow-card">
          <h1 className="m-0 text-2xl font-semibold tracking-tighter">{title}</h1>
          {hint && <p className="m-0 mt-2 text-base text-ink-muted">{hint}</p>}
          <div className="mt-6 flex flex-col gap-5">{children}</div>
        </main>

        {footer && <div className="mt-5 text-center text-base">{footer}</div>}
      </div>
    </div>
  );
}

/** The one place an auth screen reports a failed attempt. */
export function AuthError({ children }: { children: ReactNode }) {
  return (
    <p
      role="alert"
      className="m-0 rounded-xl border border-danger-edge bg-danger-wash px-4 py-3 text-base text-danger-text"
    >
      {children}
    </p>
  );
}

/** The same, for something that went right. */
export function AuthNotice({ children }: { children: ReactNode }) {
  return (
    <p className="m-0 rounded-xl border border-brand-edge/40 bg-brand-wash px-4 py-3 text-base text-brand-strong">
      {children}
    </p>
  );
}
